import styled from 'styled-components';

export const CarouselWrapper = styled.div`
  .ant-carousel {
    .slick-slide {
      height: auto !important;
      > div {
        height: 100%;
      }
    }
    .slick-list {
      height: auto !important;
    }
    .slick-track {
      height: auto !important;
    }
  }
`;
